import { h } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ErrorMessage = (props) => {

  let message = 'Something went wrong.'

  if ( props.type === 'no-results' ) {
    message = 'Geen resultaten gevonden.'
  } else if ( props.type === 'filter-error' ) {
    message = 'De filter kon niet geladen worden.'
  } else if ( props.type === 'posts-error' ) {
    message = 'De producten konden niet geladen worden. Ververs a.u.b. de pagina.'
  }

  return (
    <div className="c-products-app__error">
      <div className="c-products-app__error-message">{message}</div>
    </div>
  )

}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/js/products/components/ErrorMessage.js